import React, { useRef, useState } from 'react';
import { Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import saveIcon from '../icons/save.svg';
import AddIcon from '../icons/plusB.svg';
import ChevronDownIcon from '../icons/chevron-down.svg';
import ManualIcon from '../icons/editB.svg';
import UploadIcon from '../icons/uploadBB.svg';

export const PrimaryButton = ({ label, icon, onClick, ...rest }) => {
  return (
    <button
      onClick={onClick}
      {...rest}
      className="flex items-center justify-center px-2 h-[40px] bg-white shadow-[0px_6px_26px_rgba(98,107,125,0.07)] rounded-xl text-[#1A3B71] font-bold space-x-2"
    >
      {icon && <img src={icon} alt="" className="w-6 h-6" />}
      <span>{label}</span>
    </button>
  );
};

export const SaveCancel = ({
  onCancelClick,
  onSaveClick,
  ...rest
}) => {

  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-4" {...rest}>
      <button
        onClick={onCancelClick}
        className="w-[232px] h-[48px] text-[#333333] bg-transparent font-medium text-lg flex items-center justify-center"
        style={{ fontWeight: 600 }}
      >
        {t(`actions.cancel`)}
      </button>

      <button
        onClick={onSaveClick}
        className="w-[232px] h-[48px] bg-primary shadow-[0px_4px_10px_rgba(190,190,190,0.5)] rounded-[12px] text-white  flex items-center justify-center"
        style={{ fontWeight: 600 }}
      >
        {t(`actions.save`)}
      </button>
    </div>
  );
};

export const SaveSubmit = ({
  onSubmitClick,
  onSaveClick,
  ...rest
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-4" {...rest}>
      <button
        onClick={onSaveClick}
        className="w-[232px] h-[48px] text-[#333333] bg-transparent font-medium text-lg flex items-center justify-center"
        style={{ fontWeight: 600 }}
      >
        {t(`actions.save`)}
      </button>

      <button
        onClick={onSubmitClick}
        className="w-[232px] h-[48px] bg-primary shadow-[0px_4px_10px_rgba(190,190,190,0.5)] rounded-[12px] text-white  flex items-center justify-center"
        style={{ fontWeight: 600 }}
      >
        {t(`actions.submit`)}
      </button>
    </div>
  );
};

export const DoubleButton = ({ manual, upload, onManualClick, onUploadClick }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const fileInputRef = useRef(null);
  const { t } = useTranslation();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleFileSelect = async (event) => {
    const input = event.target;
    const file = input.files?.[0];
    if (!file) return;

    try {
      await onUploadClick?.(file);
    } finally {
      input.value = "";
    }
  };

  return (
    <div className="relative inline-block">
      <button
        onClick={handleClick}
        aria-controls={Boolean(anchorEl) ? 'simple-menu' : undefined}
        aria-haspopup="true"
        className="flex items-center justify-center px-2 h-[40px] bg-white shadow-[0px_20px_80px_#00000011] rounded-[12px] text-[#1A3B71] font-bold space-x-2"
      >
        <div className="flex items-center space-x-2">
        <img src={AddIcon} alt="Add" className="w-5 h-5" />
        <span style={{ fontFamily: "Montserrat" }}>{manual}</span>

        </div>
        <div className="flex items-center">
          <div
            style={{
              borderLeft: '1px solid #043F88',
              height: '24px',
              opacity: 0.16,
              margin: '0 8px',
            }}
          ></div>
          <img src={ChevronDownIcon} alt="Chevron Down" className="w-4 h-4" />
          </div>
      </button>

      <input
        type="file"
        ref={fileInputRef}
        accept=".xls,.xlsx"
        style={{ display: 'none' }}
        onChange={handleFileSelect}
      />

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{
              mt: 0.5,
          '& .MuiPaper-root': {
            borderRadius: '8px',
            padding: '0px 0',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          },
          '& .MuiMenuItem-root': {
            fontSize: '14px',
            fontWeight: '500',
            color: '#043F88',
            padding: '12px 16px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            '&:hover': {
              backgroundColor: '#F5F5F5',
            },
          },
        }}
      >
        {/* Menu Items */}
        <MenuItem onClick={() => { onManualClick?.(); handleClose(); }}>
          <img src={ManualIcon} alt="Manual Icon" className="w-5 h-5" />
        <span className="text-[14px] font-bold text-[#043F88]" style={{ fontFamily: "Montserrat" }}>
        {t(`placeholder.manual`)}
          </span>
        </MenuItem>
        <div
          style={{
            border: '1px solid #F7F7F7',
            opacity: 1,
            margin: '4px 16px',
          }}
        />
        <MenuItem
          onClick={() => {
            fileInputRef.current.click();
            handleClose();
          }}
        >
          <img src={UploadIcon} alt="Upload Icon" className="w-5 h-5" />
          <span className="text-[14px] font-bold text-[#043F88]" style={{ fontFamily: "Montserrat" }}>
          {upload}
          </span>
        </MenuItem>
      </Menu>
    </div>
  );
};

export const SaveCancelTop = ({ onCancel, onSave}) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-4">
      <button
        onClick={onCancel}
        className="bg-white text-[#043F88] font-bold text-[14px] px-6 py-3 rounded-[12px] hover:bg-[#E5EFFF]"
      >
        {t(`actions.cancel`)}
      </button>

      <button
        onClick={onSave}
        className="bg-[#043F88] text-white font-bold text-[14px] px-4 py-3 rounded-[12px] flex items-center gap-2 hover:bg-[#002F6D]"
      >
        <img src={saveIcon} alt="Save Icon" className="w-5 h-5" />
        {t(`actions.save`)}
      </button>
    </div>
  );
};

const Components = {
  PrimaryButton,
  SaveCancel,
  DoubleButton,
  SaveCancelTop,
  SaveSubmit
};

export default Components;
